import React from 'react'
import { Route } from 'react-router-dom'

import { auth } from '../../../services/util/auth.service'
import OrdemColetaMenu from './OrdemColetaMenu/OrdemColetaMenu'
import OrdensColeta from './OrdensColeta/OrdensColeta'
import OcorrenciasPendentes from './OcorrenciasPendentes/OcorrenciasPendentes'
import OcorrenciaAssociadas from './OcorrenciaAssociadas/OcorrenciasAssociadas'
import LocalDescarga from './LocalDescarga/LocalDescarga'
import Canhoto from '../Entrega/Canhoto/Canhoto'
import NotasFiscaisCliente from './NotasFiscaisCliente/NotasFiscaisCliente'
import NotaFiscalCliente from './NotaFiscalCliente/NotaFiscalCliente'
import NotaFiscalClienteItems from './NotaFiscalClienteItems/NotaFiscalClienteItems'
import OcorrenciasPorEntrega from './OcorrenciasPorEntrega/OcorrenciasPorEntrega'
import NotaFiscalEntrega from './NotaFiscalEntrega/NotaFiscalEntrega'
import VisualizarOrdemColeta from './VisualizarOrdemColeta/VisualizarOrdemColeta'
import AprovacaoOrdemColeta from './AprovacaoOrdemColeta/AprovacaoOrdemColeta'
import AnaliseDasOcorrencias from './AnaliseDasOcorrencias/AnaliseDasOcorrencias'
import OcorrenciasPorColaboradores from './OcorrenciasPorColaboradores/OcorrenciasPorColaboradores'
import ConferenciaOrdemColeta from './ConferenciaOrdemColeta/ConferenciaOrdemColeta'

export default function OrdemColeta() {
  return (
    <React.Fragment>
      <Route path="/main/ordemcoleta/menu" render={() => auth(<OrdemColetaMenu />)} />
      <Route path="/main/ordemcoleta/ordens-coleta" render={() => auth(<OrdensColeta />, 5)} />
      <Route
        path="/main/ordemcoleta/ocorrencias-pendentes"
        render={() => auth(<OcorrenciasPendentes />, 5)}
      />
      <Route
        path="/main/ordemcoleta/ocorrencias-associadas"
        render={() => auth(<OcorrenciaAssociadas />, 5)}
      />
      <Route path="/main/ordemcoleta/local-descarga" render={() => auth(<LocalDescarga />, 7)} />
      <Route path="/main/ordemcoleta/anexar-canhoto" render={() => auth(<Canhoto />, 5)} />
      <Route
        path="/main/ordemcoleta/notas-fiscais-cliente"
        render={() => auth(<NotasFiscaisCliente />, 5)}
      />
      <Route
        path="/main/ordemcoleta/nota-fiscal-cliente"
        render={() => auth(<NotaFiscalCliente />, 5)}
      />
      <Route
        path="/main/ordemcoleta/nota-fiscal-cliente-items"
        render={() => auth(<NotaFiscalClienteItems />, 5)}
      />
      <Route
        path="/main/ordemcoleta/ocorrencias-por-entrega"
        render={() => auth(<OcorrenciasPorEntrega />, 5)}
      />
      <Route
        path="/main/ordemcoleta/nota-fiscal-entrega"
        render={() => auth(<NotaFiscalEntrega />, 5)}
      />
      <Route path="/main/ordemcoleta/visualizar" render={() => auth(<VisualizarOrdemColeta />)} />
      <Route
        path="/main/ordemcoleta/aprovacao-ordem-coleta"
        render={() => auth(<AprovacaoOrdemColeta />, 6)}
      />
      <Route
        path="/main/ordemcoleta/analise-das-ocorrencias"
        render={() => auth(<AnaliseDasOcorrencias />, 13)}
      />
      <Route
        path="/main/ordemcoleta/ocorrencias-por-colaboradores"
        render={() => auth(<OcorrenciasPorColaboradores />, 25)}
      />
      <Route
        path="/main/ordemcoleta/conferencia-ordem-coleta"
        render={() => auth(<ConferenciaOrdemColeta />, 5)}
      />
    </React.Fragment>
  )
}
